import { Component, Input } from '@angular/core';
import { FileItem } from '../../../core/models/file';

@Component({
  selector: 'app-file-list',
  standalone: true,
  imports: [],
  templateUrl: './file-list.html'
})
export class FileList {
  @Input() files: FileItem[] = [];
  @Input() downloadPath: string = 'files/';
  @Input() isLoading: boolean = false;
  @Input() error: string | null = null;

  getFileIcon(fileName: string): string {
    const extension = fileName.toLowerCase().split('.').pop();

    // Check for Excel file extensions
    if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm' || extension === 'xlsb') {
      return 'images/Excel_file_icon.png';
    }

    // Check for PDF extension
    if (extension === 'pdf') {
      return 'images/PDF_file_icon.png';
    }

    // Default to PDF icon as fallback
    return 'images/PDF_file_icon.png';
  }
}
